/**
 * Email validation utilities for the waitlist widget
 */

export const AROHA_LABS_DOMAIN = '@arohalabs.com';

/**
 * Validates if an email address is in the correct format
 * @param email - The email address to validate
 * @returns True if the email is valid, false otherwise
 */
export function isValidEmail(email: string): boolean {
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  return emailRegex.test(email);
}

/**
 * Checks if an email address belongs to the Aroha Labs domain
 * @param email - The email address to check
 * @returns True if the email is from @arohalabs.com, false otherwise
 */
export function isArohaLabsEmail(email: string): boolean {
  return email.toLowerCase().endsWith(AROHA_LABS_DOMAIN);
}

/**
 * Determines the routing action based on email domain
 * @param email - The email address to route
 * @returns 'login' for @arohalabs.com emails, 'waitlist' for all others
 */
export function getEmailRoutingAction(email: string): 'login' | 'waitlist' {
  if (!isValidEmail(email)) {
    throw new Error('Invalid email format');
  }
  
  return isArohaLabsEmail(email) ? 'login' : 'waitlist';
}